module.exports = __webpack_public_path__ + "img/notice.3357cbfb.jpeg";